import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({ isLoggedIn, isAdmin, onLoginClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  const getLoginButtonText = () => {
    if (isAdmin) return 'Admin Panel';
    if (isLoggedIn) return 'My Account';
    return 'Login';
  };

  const getLoginButtonStyle = () => {
    if (isAdmin) {
      return {
        background: 'rgba(220, 53, 69, 0.2)',
        border: '1px solid #dc3545'
      };
    }
    if (isLoggedIn) {
      return {
        background: 'rgba(212, 175, 55, 0.2)',
        border: '1px solid #d4af37'
      };
    }
    return {};
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/" onClick={handleNavLinkClick}>
            <i className="fas fa-exchange-alt"></i>
            <span>Ooowap</span>
          </Link>
        </div>
        
        <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <li>
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`} 
              onClick={handleNavLinkClick}
            >
              Home
            </Link>
          </li>
          <li>
            <Link 
              to="/browse" 
              className={`nav-link ${isActive('/browse') ? 'active' : ''}`} 
              onClick={handleNavLinkClick}
            >
              Browse Purses
            </Link>
          </li>
          <li>
            <Link 
              to="/contact" 
              className={`nav-link ${isActive('/contact') ? 'active' : ''}`} 
              onClick={handleNavLinkClick}
            >
              Contact Us
            </Link>
          </li>
          <li>
            <Link 
              to="/faq" 
              className={`nav-link ${isActive('/faq') ? 'active' : ''}`} 
              onClick={handleNavLinkClick}
            >
              FAQ
            </Link>
          </li>
        </ul>
        
        <div className="nav-cart">
          <i className="fas fa-user"></i>
          <button 
            className="user-status" 
            onClick={onLoginClick}
            style={getLoginButtonStyle()}
          >
            {getLoginButtonText()}
          </button>
        </div>
        
        <div 
          className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={handleMobileMenuToggle}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 